import { createHandoverApi } from './handoverApi';

const LinePlannerApi = createHandoverApi({
    basePath: 'LinePlannerHandOver',
    reportName: 'LinePlanner',
});

export default LinePlannerApi;
